module.exports = __webpack_public_path__ + "img/tweetgray.2eb9dc5f.svg";